import Api from '../Api';

import { url } from './config';
import { PaymentGateway } from './model';

const api = new Api<PaymentGateway>(url);

export default api;
